export default "__VITE_ASSET__iSjAcqCV__"